export const hexToRgb = (hex: string) => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

export const hexToRgbString = (hex: string) => {
  const rgbObj = hexToRgb(hex);

  return rgbObj !== null && rgbObj.r + "," + rgbObj.g + "," + rgbObj.b;
};

export function isColorDark(color) {
  // Convert the color to its RGB components
  let r, g, b;
  if (color.startsWith("#")) {
    // Handle hexadecimal color notation (#RRGGBB)
    color = color.slice(1); // Remove the # symbol
    r = parseInt(color.substr(0, 2), 16);
    g = parseInt(color.substr(2, 2), 16);
    b = parseInt(color.substr(4, 2), 16);
  } else if (color.startsWith("rgb")) {
    // Handle rgb or rgba color notation
    const match = color.match(/\d+/g);
    r = parseInt(match[0]);
    g = parseInt(match[1]);
    b = parseInt(match[2]);
  } else {
    throw new Error("Invalid color format");
  }

  // Calculate the relative luminance of the color using the sRGB formula
  const relativeLuminance = 0.2126 * (r / 255) + 0.7152 * (g / 255) + 0.0722 * (b / 255);

  // Determine if the color is dark or bright based on the luminance value
  return relativeLuminance < 0.5; // You can adjust the threshold as needed
}
